import { DAZE_PASSAGE_ROW_HEIGHT_BY_FONT_SIZE, DAZE_PASSAGE_DEFAULT_ROW_HEIGHT } from './dazeConstants';
/* eslint-disable import/prefer-default-export */
export const getScrollStepSize = (isExtendedView, fontSizeScaleValue) => (isExtendedView ? DAZE_PASSAGE_ROW_HEIGHT_BY_FONT_SIZE[fontSizeScaleValue] : DAZE_PASSAGE_DEFAULT_ROW_HEIGHT) * 2;
